import React, { useContext, useMemo } from "react";
import { useStaticQuery, graphql } from "gatsby";
import CartContext from "./context/cart";
import Icon from "./atoms/icon";
import UserContext from "./context/user";

const Cart = ({ shopLink }) => {
  const { userData } = useContext(UserContext);
  const { cart, loadingCart, cartUrl, showCartWarning } = useContext(CartContext);
  const items = useMemo(
    () =>
      cart && cart.items?.length ? cart.items.reduce((sum, item) => sum + item.quantity, 0) : 0,
    [cart]
  );
  const showCartUrl = (!!cartUrl && (userData || items > 0)) || shopLink;

  const { labelManagerLabels } = useStaticQuery(graphql`
    {
      labelManagerLabels {
        cart
      }
    }
  `);
  const cartLabel = labelManagerLabels.cart;

  return showCartUrl ? (
    <a href={cartUrl || shopLink} className="header-tools__tool" aria-label={cartLabel} id="cart">
      <Icon name="system-cart" />
      {items ? <em className="count">{items}</em> : null}
    </a>
  ) : loadingCart ? (
    <button
      className="header-tools__tool header-tools__tool--loading-icon"
      aria-label={cartLabel}
      disabled={true}
      id="cart"
    >
      <Icon name="system-cart" />
    </button>
  ) : (
    <button
      onClick={showCartWarning}
      className="header-tools__tool"
      aria-label={cartLabel}
      id="cart"
    >
      <Icon name="system-cart" />
    </button>
  );
};

export default Cart;
